import {Expressions} from '@packages/systems/wfdl';
import type {ExpressionElement} from '@packages/systems/wfdl-ast';
import {isOptimizationVariationElement} from '@packages/utilities/platform';
import {MATCHING_VARIATION_ATOM_ID_PATH} from './constants';
import {TEMP_PATH} from '@packages/utilities/expression-path-constants';

const PATH = [...TEMP_PATH, ...MATCHING_VARIATION_ATOM_ID_PATH];

export function isMatchingVariationAtom(element: ExpressionElement): boolean {
  if (!isOptimizationVariationElement(element)) {
    return false;
  }

  return Expressions.getElementDataAt(element, PATH, 'Text', '') === element.id;
}
